// extracted by mini-css-extract-plugin
export default {"grid":"display_option-module___grid___eecd17b9","cell":"display_option-module___cell___c501d181","header":"display_option-module___header___afdaf6f3"};